function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert } from "@mui/material";
import cn from "clsx";
import { Formik, Form as FormikForm, getIn, useFormikContext, yupToFormErrors } from "formik";
import { createContext, forwardRef, memo, useCallback, useEffect, useMemo, useState } from "react";
import { useDebounce, useToggle, useUnmount, useUpdateEffect } from "react-use";
export var FORM_SUBMIT_ERROR = 'error';
/**
 * this is a wrapper for the Confirm prop/component; it
 * implements to subsequent submission post confirmation
 */ var FormConfirm = /*#__PURE__*/ memo(function(_param) {
    var Confirm = _param.Confirm, isConfirmed = _param.isConfirmed, props = _object_without_properties(_param, [
        "Confirm",
        "isConfirmed"
    ]);
    var ctx = useFormikContext();
    useUpdateEffect(function() {
        if (!props.open && isConfirmed) {
            _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                ctx.handleSubmit()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    }, [
        isConfirmed
    ]);
    return /*#__PURE__*/ _jsx(Confirm, _object_spread_props(_object_spread({}, props), {
        values: ctx.values
    }));
});
/**
 * this is a workaround for adding an onChange callback to Form
 * unfortunately, formik does not provide onChange callback (only <form onChange>)
 */ var FormChangeHandler = /*#__PURE__*/ memo(function(props) {
    var ctx = useFormikContext();
    var _useState = _sliced_to_array(useState(false), 2), mounted = _useState[0], setMounted = _useState[1];
    useEffect(function() {
        var $timeout = setTimeout(function() {
            setMounted(true);
        }, 10);
        return function() {
            clearTimeout($timeout);
        };
    }, []);
    var _useDebounce = _sliced_to_array(useDebounce(function() {
        var shouldCall = !props.preventOnChangeOnMount || props.preventOnChangeOnMount && mounted;
        if (props.onChange && shouldCall) {
            props.onChange(ctx.values);
        }
    }, 10, [
        ctx.values
    ]), 2), cancel = _useDebounce[1];
    useUnmount(function() {
        cancel();
    });
    return null;
});
/**
 * this is a workaround for adding an onValidation callback to Form
 * unfortunately, formik does not provide onValidation callback
 */ var FormValidationHandler = /*#__PURE__*/ memo(function(props) {
    var ctx = useFormikContext();
    useEffect(function() {
        props.onValidation(ctx.isValid);
    }, [
        ctx.isValid
    ]);
    return null;
});
/**
 * this is a workaround for adding an onErrors callback to Form
 * unfortunately, formik does not provide onErrors callback
 */ var FormErrorHandler = /*#__PURE__*/ memo(function(props) {
    var ctx = useFormikContext();
    useEffect(function() {
        if (props.onErrors) {
            props.onErrors(ctx.errors);
        }
    }, [
        ctx.errors
    ]);
    return null;
});
/**
 * this is a workaround to re-validate form when schema changes
 */ var FormValidationSchemaChanged = /*#__PURE__*/ memo(function(props) {
    var ctx = useFormikContext();
    useUpdateEffect(function() {
        ctx.validateForm();
    }, [
        props.validationSchema
    ]);
    return null;
});
export var IsRequiredFieldContext = /*#__PURE__*/ createContext({});
export var Form = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var Confirm = _param.Confirm, _param_enableReinitialize = _param.enableReinitialize, enableReinitialize = _param_enableReinitialize === void 0 ? true : _param_enableReinitialize, _param_initialValues = _param.initialValues, initialValues = _param_initialValues === void 0 ? {} : _param_initialValues, _param_validateOnBlur = _param.validateOnBlur, validateOnBlur = _param_validateOnBlur === void 0 ? true : _param_validateOnBlur, _param_validateOnChange = _param.validateOnChange, validateOnChange = _param_validateOnChange === void 0 ? true : _param_validateOnChange, _param_validateOnMount = _param.validateOnMount, validateOnMount = _param_validateOnMount === void 0 ? true : _param_validateOnMount, props = _object_without_properties(_param, [
        "Confirm",
        "enableReinitialize",
        "initialValues",
        "validateOnBlur",
        "validateOnChange",
        "validateOnMount"
    ]);
    var _useToggle = _sliced_to_array(useToggle(false), 2), isConfirmed = _useToggle[0], toggleIsConfirmed = _useToggle[1];
    var _useToggle1 = _sliced_to_array(useToggle(false), 2), showConfirm = _useToggle1[0], toggleShowConfirm = _useToggle1[1];
    var onConfirm = useCallback(function() {
        toggleIsConfirmed(true);
        toggleShowConfirm(false);
    }, []);
    var onDismiss = useCallback(function() {
        toggleIsConfirmed(false);
        toggleShowConfirm(false);
    }, []);
    /** wrapper around callback to provide validationContext to the yup schema */ var onValidate = useCallback(function() {
        var _ref = _async_to_generator(function(values) {
            var e;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (props.validate) {
                            return [
                                2,
                                props.validate(values)
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            props.validationSchema.validate(values, {
                                abortEarly: false,
                                context: _object_spread({}, props.validationContext || {})
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        if (props.onRawErrors) {
                            props.onRawErrors(e);
                        }
                        return [
                            2,
                            yupToFormErrors(e)
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(values) {
            return _ref.apply(this, arguments);
        };
    }(), [
        props.onRawErrors,
        props.validate,
        props.validationContext,
        props.validationSchema
    ]);
    var onReset = useCallback(function(values, ctx) {
        if (Confirm && isConfirmed) {
            toggleIsConfirmed(false);
        }
        if (props.onReset) {
            return props.onReset(values, ctx);
        }
    }, [
        Confirm,
        isConfirmed,
        props.onReset
    ]);
    var onSubmit = useCallback(function() {
        var _ref = _async_to_generator(function(values, ctx) {
            var result, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isConfirmed && Confirm) {
                            toggleShowConfirm(true);
                            ctx.setSubmitting(false);
                            return [
                                2
                            ];
                        }
                        if (!props.onSubmit) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            props.onSubmit(values, ctx)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = undefined;
                        _state.label = 3;
                    case 3:
                        result = _tmp;
                        toggleIsConfirmed(false);
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(values, ctx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        Confirm,
        isConfirmed,
        props.onSubmit
    ]);
    var isRequiredFieldValue = useMemo(function() {
        if (!props.validationSchema) {
            return {};
        }
        var _props_validationSchema_describe_fields;
        var fields = (_props_validationSchema_describe_fields = props.validationSchema.describe().fields) !== null && _props_validationSchema_describe_fields !== void 0 ? _props_validationSchema_describe_fields : {};
        return Object.keys(fields).reduce(function(acc, field) {
            var _getIn_tests, _getIn;
            return _object_spread_props(_object_spread({}, acc), _define_property({}, field, !!((_getIn = getIn(fields, field)) === null || _getIn === void 0 ? void 0 : (_getIn_tests = _getIn.tests) === null || _getIn_tests === void 0 ? void 0 : _getIn_tests.find(function(test) {
                return test.name === 'required';
            }))));
        }, {});
    }, []);
    var ariaLabel = props['aria-label'];
    var ariaLabelledBy = props['aria-labelledby'];
    return /*#__PURE__*/ _jsx(IsRequiredFieldContext.Provider, {
        value: isRequiredFieldValue,
        children: /*#__PURE__*/ _jsx(Formik, {
            autoComplete: props.autoComplete,
            enableReinitialize: enableReinitialize,
            initialTouched: props.initialTouched,
            initialValues: initialValues,
            innerRef: ref,
            onReset: onReset,
            onSubmit: onSubmit,
            validate: onValidate,
            validateOnBlur: validateOnBlur,
            validateOnChange: validateOnChange,
            validateOnMount: validateOnMount,
            children: /*#__PURE__*/ _jsxs(FormikForm, _object_spread_props(_object_spread({}, ariaLabel ? {
                'aria-label': ariaLabel
            } : {}, ariaLabelledBy ? {
                'aria-labelledby': ariaLabel
            } : {}), {
                autoComplete: props.autoComplete,
                className: props.className,
                "data-component": props['data-component'] || 'Form',
                "data-testid": props['data-testid'],
                children: [
                    props.children,
                    Confirm && /*#__PURE__*/ _jsx(FormConfirm, {
                        Confirm: Confirm,
                        confirm: onConfirm,
                        dismiss: onDismiss,
                        isConfirmed: isConfirmed,
                        open: showConfirm
                    }),
                    props.onValidation && /*#__PURE__*/ _jsx(FormValidationHandler, {
                        onValidation: props.onValidation
                    }),
                    props.onChange && /*#__PURE__*/ _jsx(FormChangeHandler, {
                        onChange: props.onChange,
                        preventOnChangeOnMount: props.preventOnChangeOnMount
                    }),
                    props.onErrors && /*#__PURE__*/ _jsx(FormErrorHandler, {
                        onErrors: props.onErrors
                    }),
                    /*#__PURE__*/ _jsx(FormValidationSchemaChanged, {
                        validationSchema: props.validationSchema
                    })
                ]
            }))
        })
    });
});
export var FormErrors = function(props) {
    var errors = useFormikContext().errors;
    if (!errors.form && !props.renderPlaceholder) return null;
    if (Array.isArray(errors.form)) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: errors.form.map(function(error) {
                return /*#__PURE__*/ _jsx(Alert, {
                    className: cn('w-fit-content mb-4', props.className),
                    severity: "error",
                    children: error
                }, error);
            })
        });
    } else if (typeof errors.form === 'string') {
        return /*#__PURE__*/ _jsx(Alert, {
            className: cn('w-fit-content mb-4', props.className),
            severity: "error",
            children: errors.form
        });
    } else if (props.renderPlaceholder === true) {
        return /*#__PURE__*/ _jsx("span", {
            "aria-hidden": "true",
            className: "block h-6"
        });
    } else {
        // handle generic validation results, e.g. `true` without messaging
        return null;
    }
};
Form.displayName = 'Form';

//# sourceMappingURL=Form.js.map